import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,400&display=swap&subset=latin');

  body {
    font-family: 'Open Sans', sans-serif;
    /* font-family: ${(props) => props.theme.fontFamily.fontFamilyName}; */
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  textarea {
    font-family: 'Open Sans', sans-serif !important;
  }

  body h4 {
    font-size: ${(props) => props.theme.fontStyles.largeFont.fontSize}px; 
  }

  body h3 {
    font-size: ${(props) => props.theme.fontStyles.largeFont.fontSize}px; 
  }

  body h2 {
    font-size: ${(props) => props.theme.fontStyles.xlFont.fontSize}px; 
  }

  body h1 {
    font-size: ${(props) => props.theme.fontStyles.xxlFont.fontSize}px; 
  }

  body h1,
  body h2,
  body h3,
  body h4,
  body h5,
  body h6 {
    color: ${(props) => props.theme.colors.discrete50};
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 0.5rem; }

  body p {
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1.5; }

  body p.error {
    color: ${(props) => props.theme.colors.error}; }

  body a {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none; 
    cursor: pointer;
    }

  body a:hover {
    color: ${(props) => props.theme.colors.discrete};
    text-decoration: none; }

  body a:focus {
    color: ${(props) => props.theme.colors.discrete};
    text-decoration: none; }

  em {
    font-weight: bold;
  }
`;

export default GlobalStyle;
